import React from "react";
import { Modal, Button, Typography } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { useGlobal } from "../../contexts/GlobalContext";
import { FORCE_EMAIL_BINDING } from "../../config/featureFlags";

const { Paragraph } = Typography;

/**
 * 首次进入时强制通过邮箱绑定门。
 * - 默认由 FORCE_EMAIL_BINDING 关闭，就绪后再开启。
 * - 未绑邮箱时，在非「账号设置」页用不可关闭的弹窗拦截，引导去设置页绑定；
 *   在设置页放行，让用户用已有的“修改邮箱”流程完成绑定。
 * - 用户信息未加载完（user 为 null）时不拦截，避免误判。
 */
const EmailBindingGate: React.FC = () => {
  const { user } = useGlobal();
  const navigate = useNavigate();
  const location = useLocation();

  if (!FORCE_EMAIL_BINDING) return null;
  if (!user) return null;
  const email = user?.apiInfo?.email;
  if (email) return null;
  // 设置页放行，让用户完成绑定。
  if (location.pathname.startsWith("/settings")) return null;

  return (
    <Modal
      open
      closable={false}
      maskClosable={false}
      keyboard={false}
      title="请先绑定邮箱"
      footer={
        <Button type="primary" onClick={() => navigate("/settings")}>
          去绑定邮箱
        </Button>
      }
    >
      <Paragraph>
        为保障账号安全，以及账号注销时的数据归档能够通过邮件交付给你，请先绑定邮箱后再继续使用。
      </Paragraph>
    </Modal>
  );
};

export default EmailBindingGate;
